import React from 'react';
import './OfflineBanner.css';

const OfflineBanner = () => (
  <div className="offline-banner" role="alert" data-offline>
    <span>💢 You are offline. Some features may be unavailable.</span>
  </div>
);

export default OfflineBanner;
